import React from 'react';
import LoadingMask from 'partial/OfferManager/LoadingMask';
import AutoRefinanceModuleView from 'partial/OfferManager/modules/AutoRefinanceModuleRedesign/AutoRefinanceModuleView';
import {
  buildAutoRefinanceloanDetails,
  buildAutoLoanQueryObject,
  REFINANCE,
} from 'helpers/autoLoan.helper';
import { completeAutoLoanFormForOffers } from 'actions/product.actions';
import { getOpenAutoLoanAccounts } from 'helpers/credit_info';
import { useEffect } from 'react';
import { setSelectedAutoLoanRefi } from 'helpers/localstorage';
import { useAutoMarketplace } from '../AutoLoanOffersMarketplaceModule/hooks/autoMarketplace.hook';

export const AutoRefinanceModuleController = props => {
  const loading = props.globalLoadingFlag;

  const { creditInfo, userInfo, dispatch, additionalData } = props;

  const autoLoanAccounts = getOpenAutoLoanAccounts(creditInfo);

  const refinanceAccount = autoLoanAccounts.find(
    refinance =>
      refinance?.name === additionalData?.OPEN_AUTO_LOAN_ACCOUNT_NAME,
  );

  const refinanceIndex = autoLoanAccounts.findIndex(
    refinance =>
      refinance?.name === additionalData?.OPEN_AUTO_LOAN_ACCOUNT_NAME,
  );

  const onClickSeeAllOptions = productKey => {
    setSelectedAutoLoanRefi(refinanceIndex + 1);
    props.history.push(
      `offers?vertical=AUTO_LOAN&auto_refinance_key=${productKey}`,
    );
  };

  useAutoMarketplace({
    creditInfo,
    userInfo,
    isRefinanceOffersRequired: true,
    autoLoanTab: {
      selectedTab: 'Refinance',
    },
  });

  useEffect(() => {
    if (refinanceAccount && creditInfo && userInfo) {
      const currentLoanDetails = buildAutoRefinanceloanDetails(
        refinanceAccount,
        creditInfo,
      );
      let queryObject;
      queryObject = buildAutoLoanQueryObject(
        creditInfo,
        userInfo,
        {
          autoLoanPurpose: REFINANCE,
          loanAmount: currentLoanDetails.balance,
          rate: currentLoanDetails.apr,
          monthlyPayment: currentLoanDetails.monthlyPayment,
        },
        false,
      );
      dispatch(
        completeAutoLoanFormForOffers({
          queryObject,
          autoLoanType: 'Refinance',
          currentLoanDetails,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <LoadingMask />;
  } else {
    return (
      <AutoRefinanceModuleView
        {...props}
        onClickSeeAllOptions={onClickSeeAllOptions}
      />
    );
  }
};
